module.exports = __webpack_public_path__ + "img/jcu.ef0e9323.jpeg";